import { LoadingState, MonoLabel } from '@/component';
import { usePurchases, type Purchase } from '@/hook';
import { formatUsd } from '@/lib/money';
import { formatReceiptDate } from '@/lib/time';

const KIND = { pack: 'Pack', track: 'Single', night_pass: 'Pass' } satisfies Record<Purchase['kind'], string>;

/** Settings, Purchases: packs, singles and passes bought outright, with the
 * reassurance that they survive a cancellation. */
export function PurchasesTab() {
  const purchases = usePurchases();
  if (!purchases) return <LoadingState />;
  return (
    <div className="mt-10 max-w-[820px]">
      <h2 className="border-b border-line pb-3 text-[15px] font-semibold">One-off purchases</h2>
      {purchases.length === 0 ? (
        <p className="py-5 text-sm text-mute">Nothing bought outright yet. Packs and passes you buy show here.</p>
      ) : (
        purchases.map((row) => (
          <div
            key={row._id}
            className="grid grid-cols-[minmax(0,2fr)_minmax(0,1.2fr)_90px_80px] items-center gap-[18px] border-b border-stripeA py-4"
          >
            <div className="min-w-0">
              <div className="truncate text-[15px] font-semibold tracking-[-0.01em]">{row.title}</div>
              <div className="mt-[2px] text-[13px] text-mute">{row.subtitle}</div>
            </div>
            <MonoLabel size="md" className="tracking-[0.1em]">
              {KIND[row.kind]}
              {row.status === 'refunded' ? ' · refunded' : ''}
            </MonoLabel>
            <span className="text-right font-mono text-[13px] text-mute">{formatReceiptDate(row.at)}</span>
            <span className="text-right font-mono text-[13px] tabular-nums">{formatUsd(row.amountCents)}</span>
          </div>
        ))
      )}
      <p className="mt-[22px] text-sm text-mute">Anything you buy outright stays yours, with or without a subscription.</p>
    </div>
  );
}
